import LoginCallback from "../../../Pages/Public/Login/LoginCallback";
import Unauthorised from "../../../Pages/Public/Unauthorised";
import Login from "../../../Pages/Public/Login/Login";
import NoRights from "../../../Pages/Public/NoRights";
import OutOfService from "../../../Pages/Public/OutOfService/OutOfService";
import { LoginCallback as OktaLoginCallback } from "@okta/okta-react";
import NotSupported from "../../../Pages/Public/NotSupported/NotSupported";
import { IRoute } from "./Routes";
import AccessDenied from "../../../Pages/Public/AccessDenied";
import LoginSuccess from "../../../Pages/Public/Login/LoginSuccess";

export default class PublicRoutes
{
    public routes: IRoute<any>[] = [
        {
            isPublic: true,
            requiredRights: [],
            path: "/norights",
            component: NoRights,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/out-of-service",
            component: OutOfService,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/unauthorised",
            component: Unauthorised,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/login",
            component: Login,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/implicit/callback",
            component: OktaLoginCallback,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/auth",
            component: LoginCallback,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/login/success",
            component: LoginSuccess,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/not-supported",
            component: NotSupported,
        },
        {
            requiredRights: [],
            path: "/access-denied",
            component: AccessDenied,
        },
    ];
}
